module.exports = __webpack_public_path__ + "img/JAKARTA-POST-967x683.7587bd8c.png";